import { Point2D } from "@dextall/common-utilities";
import { PanelCladdingCell, PanelHook } from "@dextall/panel-hooks-editor-2d";
import colorsFactory from "../../colors/ralColorsFactory";
import { CornerHook } from "../cornerHook";
import { Hook } from "../hook";
import { Panel } from "../panel";

export const createEditorCladdingCells = (panel: Panel): PanelCladdingCell[] => {
    return panel.claddingCells.map(x => ({
        box: new THREE.Box3(
            new THREE.Vector3().subVectors(x.box.min, panel.box.min).multiplyScalar(editorUnitsFactor),
            new THREE.Vector3().subVectors(x.box.max, panel.box.min).multiplyScalar(editorUnitsFactor),
        ),
        color: claddingCellToHtmlColor(x.color),
    }));
};

export const createPanelEditorHook = (hook: Hook | CornerHook): PanelHook => {
    return {
        position: {
            x: hook.x * editorUnitsFactor,
            y: hook.y * editorUnitsFactor,
        },
    };
};

export const convertPanelEditorPositionToModelCoordinates = (position: Point2D): Point2D => {
    return {
        x: position.x / editorUnitsFactor,
        y: position.y / editorUnitsFactor,
    };
};

const claddingCellToHtmlColor = (cellColor: string) => {
    return colorsFactory.getColor(cellColor) || fallbackColor;
};

const editorUnitsFactor = Autodesk.Viewing.Private.convertUnits("ft", "mm", 1, 1);
const fallbackColor = "#FFFFFF";
